package com.parmartechnologies.storage.table.inventory.brand

import com.parmartechnologies.core.feature.inventory.brand.model.Brand
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable

class BrandDatabaseTable : DatabaseTable() {
    fun insert(item: Brand?) {
        item?.let {
            DatabaseCollection().insert(item, Brand.serializer())
        }
    }

    fun insert(items: List<Brand>?) {
        items?.let {
            DatabaseCollection().insertAll(items, Brand.serializer())
        }
    }

    fun retrieve(id: String, callback: (List<Brand>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("business_id",id),Pair("product_id",id))
        DatabaseCollection().findAll(andQuery, Brand.serializer()){
            callback(it)
        }
    }

    fun retrieveAll(id: String, callback: (List<Brand>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id, Brand.serializer()){
            callback(it)
        }
//        val andQuery : Map<String,Any> = mapOf()
//        DatabaseCollection().findAll(andQuery, Brand.serializer()){
//            callback(it)
//        }
    }

    fun find(id: String, callback: (Brand?) -> Unit) {
//        val table = AppDatabase.shared().database?.brandTableQueries
//        var itemsFetched: Brand? = null
//        scope.launch {
//            val items = table?.find(id)?.awaitAsOneOrNull()
//            items?.let { item ->
//                itemsFetched = convert(item)
//            }
//            callback(itemsFetched)
//        }
    }


    fun LastSyncDate(id: String, callback: (String?) -> Unit) {
//        val table = AppDatabase.shared().database?.sizeTableQueries
//        scope.launch {
//            val dateFromDb = table?.LastSyncDate(id)?.awaitAsOneOrNull()
//            callback(dateFromDb?.UpdatedAt)
//        }
    }

//    fun convert(item: BrandTable): Brand {
//        return Brand(
//            Id = item._id,
//            BrandID = item.BrandID,
//            UserID = item.UserID,
//            BusinessID = item.BusinessID,
//            IsDeleted = item.IsDeleted,
//            Name = item.Name,
//            Description = item.Description,
//            CreatedAt = item.CreatedAt,
//            UpdatedAt = item.UpdatedAt,
//        )
//    }
}